import { useMemo } from 'react';
import { useFeatureFlagsStore } from '../stores/featureFlagsStore';
import {
  DEFAULT_COURSE_LABEL_SINGULAR,
  DEFAULT_COURSE_LABEL_PLURAL,
  ALL_COURSES_SELECT_VALUE,
} from '../types/featureFlags';

/**
 * User-configurable UI labels for course/domain grouping (default Domain / Domains).
 * Does not change API field names (`course_id`, etc.) or the select sentinel {@link ALL_COURSES_SELECT_VALUE}.
 */
export function useCourseLabels() {
  const singularRaw = useFeatureFlagsStore((s) => s.courseLabelSingular);
  const pluralRaw = useFeatureFlagsStore((s) => s.courseLabelPlural);
  const setCourseLabelSingular = useFeatureFlagsStore((s) => s.setCourseLabelSingular);
  const setCourseLabelPlural = useFeatureFlagsStore((s) => s.setCourseLabelPlural);

  return useMemo(() => {
    const courseSingular =
      (singularRaw && singularRaw.trim()) || DEFAULT_COURSE_LABEL_SINGULAR;
    const coursePlural = (pluralRaw && pluralRaw.trim()) || DEFAULT_COURSE_LABEL_PLURAL;
    return {
      courseSingular,
      coursePlural,
      courseSingularLower: courseSingular.toLowerCase(),
      coursePluralLower: coursePlural.toLowerCase(),
      /** Menu label for the “everything” option; value must stay {@link ALL_COURSES_SELECT_VALUE}. */
      allLabel: `All ${coursePlural}`,
      allValue: ALL_COURSES_SELECT_VALUE,
      setCourseLabelSingular,
      setCourseLabelPlural,
    };
  }, [
    singularRaw,
    pluralRaw,
    setCourseLabelSingular,
    setCourseLabelPlural,
  ]);
}
